<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6" lg="3">
        <b-card>
          <div class="card-block">
            <div class="h4 m-0">77%</div>
            <div>Compliance Monitoring</div>
            <div class="progress progress-xs my-3">
              <div class="progress-bar bg-success" role="progressbar" style="width: 77%" aria-valuenow="77" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted">Compliance Monitoring Status.</small>
          </div>
        </b-card>
      </b-col><!--/.col-->
      <b-col sm="6" lg="3">
        <b-card>
          <div class="card-block">
            <div class="h4 m-0">22%</div>
            <div>Surveys Completed</div>
            <div class="progress progress-xs my-3">
              <div class="progress-bar bg-danger" role="progressbar" style="width: 22%" aria-valuenow="22" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted">Surveys Completed for April.</small>
          </div>
        </b-card>
      </b-col><!--/.col-->
      <b-col sm="6" lg="3">
        <b-card>
          <div class="card-block">
            <div class="h4 m-0">60%</div>
            <div>User Profile Completion Progress</div>
            <div class="progress progress-xs my-3">
              <div class="progress-bar bg-warning" role="progressbar" style="width: 60%" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted">Complete your profile to 100% for the best experience.</small>
          </div>
        </b-card>
      </b-col><!--/.col-->
      <b-col sm="6" lg="3">
        <b-card>
          <div class="card-block">
            <div class="h4 m-0">100%</div>
            <div>Open Compliance Progress</div>
            <div class="progress progress-xs my-3">
              <div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <small class="text-muted">Open Compliance Progress.</small>
          </div>
        </b-card>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  <b-row>
    <b-col sm="6" md="4">
      <b-card header="Upcoming Reminders">
        <div class="card-block">
          <a href="#">CSPD Decontamination Survey Due Today.</a><br>
          <a href="#">Quality Culture Communication Due Next Week</a><br>
        </div>
      </b-card>
    </b-col><!--/.col-->
    <b-col sm="6" md="4">
      <b-card header="Market News Updates">
        <div class="card-block">
          <NewsItems></NewsItems>
        </div>
      </b-card>
    </b-col><!--/.col-->
    <b-col sm="6" md="4">
        <b-card header="Helpful Industry Links">
          <div class="card-block">
            <Links></Links>
          </div>
        </b-card>
      </b-col><!--/.col-->
  </b-row><!--/.row-->
</div>
</template>
<script>
import NewsItems from '@/views/components/NewsItems'
import Links from '@/views/components/Links'

export default {
  name: 'mymountain',
  components: {NewsItems,
    Links
  }
}
</script>
